<template>
  <div class="custom-made-cate">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:180px"
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.custom_made_cate_id"
                  clearable
                  filterable
                  placeholder="选择分类">
            <Option v-for="item in custommadecateList"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入定制名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>

        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- <Drawer :title="title"
            v-model="showModalStatus"
            width="600"
            :styles="styles"
            :mask-closable="false"
            :closable="true">
      <Form :model="dataInfo"
            label-position="left"
            :label-width="100">
        <FormItem label="分类">
          <span v-if="dataInfo.cate !='' ">{{ dataInfo.cate.title }}</span>
        </FormItem>
        <FormItem label="名称"
                  prop="title">
          <span>{{ dataInfo.title }}</span>
        </FormItem>
        <FormItem label="关键字"
                  prop="title">
          <span>{{ dataInfo.keyword }}</span>
        </FormItem>
        <FormItem label="价格区间"
                  prop>
          <span>{{ dataInfo.price_range }}</span>
        </FormItem>
        <FormItem label="定制截止日期"
                  prop>
          <span>{{ dataInfo.end_at }}</span>
        </FormItem>
        <FormItem label="图集"
                  prop="album">
          <div class="upload-list"
               v-for="item in dataInfo.attrShow"
               :key="item">
            <img :src="item" />
          </div>
        </FormItem>
        <FormItem label="最终价格"
                  prop="price">
          <span>{{ dataInfo.price }}</span>
        </FormItem>
        <FormItem label="划线价格">
          <span>{{ dataInfo.underline_price }}</span>
        </FormItem>
        <FormItem label="描述"
                  label-position="top"
                  prop="descript">
          <span>{{ dataInfo.descript }}</span>
        </FormItem>
        <FormItem label="内容"
                  prop="content">
          <span v-html="dataInfo.content"></span>
        </FormItem>
        <FormItem label="是否代理商户分销"
                  prop="is_fx">
          <span v-if="dataInfo.is_fx ==1">是</span>
          <span v-else>否</span>
        </FormItem>
        <FormItem label="代理商户分销比例"
                  label-position="top">
          <span>{{ dataInfo.agent_fx }}</span>
        </FormItem>
        <FormItem label="是否开放购买"
                  prop="is_buy">
          <span v-if="dataInfo.is_buy ==1">是</span>
          <span v-else>否</span>
        </FormItem>
        <FormItem label="是否推荐"
                  prop="is_recommend">
          <span v-if="dataInfo.is_recommend ==1">是</span>
          <span v-else>否</span>
        </FormItem>
        <FormItem label="状态"
                  prop="is_fx">
          <span v-if="dataInfo.status ==1">通过</span>
          <span v-else-if="dataInfo.status ==-1">驳回</span>
          <span v-else>待审核</span>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
      </div>
    </Drawer> -->
    <!-- 添加的弹出 -->
    <!--<Modal v-model="showModalStatus" :title="title" @on-ok="createInfo('dataInfoValidate')" :loading="loading">-->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="800"
            :mask-closable="false"
            :styles="styles">
      <Form :model="dataInfo"
            ref="dataInfoValidate"
            :label-width="80"
            :rules="dataInfoValidate"
            action="javascript:void(0)">
        <FormItem label="分类"
                  prop="title">
          <Select v-model="dataInfo.custom_made_cate_id"
                  clearable
                  filterable
                  placeholder="选择分类">
            <Option v-for="item in custommadecateList"
                    :value="item.id"
                    :key="item.id">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称"
                  prop="title">
          <Input v-model="dataInfo.title"
                 placeholder="输入名称..."></Input>
        </FormItem>
        <FormItem label="关键字"
                  prop="keyword">
          <Input v-model="dataInfo.keyword"
                 placeholder="输入关键字,多个用','分隔"></Input>
        </FormItem>
        <FormItem label="价格区间"
                  prop="price_range">
          <Input v-model="dataInfo.price_range"
                 placeholder="价格区间..."></Input>
        </FormItem>
        <FormItem label="订购量"
                  prop="accept_order_count">
          <Input v-model="dataInfo.accept_order_count"
                 placeholder="订购量 0不限制..."></Input>
        </FormItem>
        <!--<FormItem label="定制周期" prop="order_cycle">-->
        <!--<Input v-model="dataInfo.order_cycle" placeholder="定制周期..."></Input>-->
        <!--</FormItem>-->
        <FormItem label="定制截止日期"
                  prop="end_at">
          <DatePicker type="date"
                      placeholder="请选择截止日期"
                      v-model="dataInfo.end_at"
                      @on-change="changeBeginDate"
                      style="width: 200px"></DatePicker>
        </FormItem>
        <FormItem label="制作周期"
                  prop="made_cycle">
          <Input v-model="dataInfo.made_cycle"
                 placeholder="输入制作周期..."></Input>
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="dataInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="330"
                        :autoCropHeight="330"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:330*330'"></upload-thumb>
        </FormItem>
        <FormItem label="图集"
                  prop="album">
          <upload-thumb v-model="dataInfo.album"
                        ref="uploadthumbTwo"
                        :defaultList="thumblistTwo"
                        :autoCropWidth="750"
                        :autoCropHeight="750"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750'"></upload-thumb>
        </FormItem>
        <FormItem label="选择上传视频方式"
                  prop="album">
          <RadioGroup v-model="dataInfo.video_type">
            <Radio label="1">直接上传</Radio>
            <Radio label="0">手动输入链接</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="上传视频"
                  prop="video_url">
          <upload-video v-model="dataInfo.video_url"
                        v-if="this.dataInfo.video_type == 1"
                        ref="uploadvideo"
                        :defaultList="videolist"></upload-video>
          <Input v-model="dataInfo.other_video_url"
                 v-else
                 placeholder="输入视频地址..."></Input>
        </FormItem>
        <FormItem label="最终价格"
                  prop="price">
          <Input v-model="dataInfo.price"
                 placeholder="最终价格..."></Input>
        </FormItem>
        <FormItem label="支付方式">
          <RadioGroup v-model="dataInfo.pay_type">
            <Radio label="1">分批</Radio>
            <Radio label="2">全额</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="描述"
                  label-position="top"
                  prop="descript">
          <Input type="textarea"
                 v-model="dataInfo.descript"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="内容"
                  prop="content">
          <UEditor v-model="dataInfo.content"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="是否代理商户分销"
                  prop="is_fx">
          <RadioGroup v-model="dataInfo.is_fx"
                      @on-change="agentFx">
            <Radio :label="0">否</Radio>
            <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="使用充值卡">
          <RadioGroup v-model="dataInfo.is_chargecard">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="代理商户分销比例"
                  label-position="top">
          <Input v-model="dataInfo.agent_fx"
                 :disabled="isable"
                 style="width:100px"
                 @on-keyup="sum();"></Input>
          <span>*平台扣除服务费10%，分销比例是让利给分销商家的推广利润</span>
          <Alert type="warning">分销可得:￥{{fx}}</Alert>
        </FormItem>
        <FormItem label="代理商户分销金额"
                  label-position="top">
          <Input v-model="dataInfo.agent_fx_money"
                 :disabled="isable"
                 style="width:100px"
                 @on-keyup="sum1()">
          </Input>
          <span>*让利给分销商家的推广利润</span>
        </FormItem>
        <FormItem label="是否开放购买"
                  prop="is_buy">
          <RadioGroup v-model="dataInfo.is_buy">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
          <Alert type="warning">开放购买有助于提高曝光度</Alert>
        </FormItem>
        <FormItem label="选择匠人"
                  label-position="top">
          <Select ref="tradselect"
                  v-model="dataInfo.from_uuid"
                  clearable
                  filterable
                  placeholder="选择匠人">
            <Option v-for="item in trandList"
                    :value="item.uuid"
                    :key="item.id">{{item.nickname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="定制价格"
                  label-position="top">
          <Row v-for="(item,index) in ruleList">
            <Col :xs="11"
                 :sm="11"
                 style="padding-right:20px">
            <Input v-model="item.phone"
                   placeholder="请输入手机号"
                   style="width: 100%;height:40px;line-height:40px"
                   :class="item.status ?'' :'borderRed'"
                   @on-blur="blurPhoneFun(index)" />
            </Col>
            <Col :xs="11"
                 :sm="11"
                 style="padding-right:20px">
            <Input v-model="item.price"
                   placeholder="请输入定制价格"
                   type="number"
                   style="width: 100%;height:40px;line-height:40px"
                   :class="item.status ?'' :'borderRed'" />
            </Col>
            <Col :xs="2"
                 :sm="2">
            <Icon type="md-trash"
                  size="30"
                  style="margin-top:5px"
                  @click="deleteRule(index)" />
            </Col>
          </Row>
          <Row>
            <Col span="4">
            <Button type="primary"
                    @click="addGoodRule">添加</Button>
            </Col>
          </Row>
        </FormItem>
      </Form>
      <div>
        <Button style="float:right;"
                @click="showModalStatus = false">取消</Button>
        <Button style="float:right;"
                type="primary"
                @click="createInfo('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>

    <Modal v-model="showPriceModalStatus"
           :title="title"
           @on-ok="editPrice('priceInfoValidate')"
           :loading="loading">
      <Form :model="priceInfo"
            ref="priceInfoValidate"
            :rules="priceInfoValidate"
            action="javascript:void(0)">
        <FormItem label="最终价格"
                  prop="price">
          <Input v-model="priceInfo.price"
                 placeholder="最终价格..."></Input>
        </FormItem>
        <FormItem label="划线价格">
          <Input v-model="priceInfo.underline_price"
                 placeholder="划线价格..."></Input>
        </FormItem>
        <FormItem label="是否开放购买"
                  prop="is_buy">
          <RadioGroup v-model="priceInfo.is_buy">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!-- 审核 -->
    <Modal v-model="showReviewModalStatus"
           :title="title"
           @on-ok="review('reviewInfoValidate')"
           :loading="loading">
      <Form :model="reviewInfo"
            ref="reviewInfoValidate"
            :rules="reviewInfoValidate"
            action="javascript:void(0)">
        <FormItem label="审核状态">
          <Select v-model="reviewInfo.status"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注"
                  prop="comment">
          <Input v-model="reviewInfo.comment"
                 placeholder="备注..."></Input>
        </FormItem>
      </Form>
    </Modal>

    <!-- 分类 -->
    <Modal v-model="showTypeModalStatus"
           :title="title"
           @on-ok="editType()"
           :loading="loading">
      <Form :model="typeInfo"
            action="javascript:void(0)">
        <FormItem label="好去处">
          <RadioGroup v-model="typeInfo.is_good_where">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="好手艺">
          <RadioGroup v-model="typeInfo.is_good_craft">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="好体验">
          <RadioGroup v-model="typeInfo.is_good_experience">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="好食材">
          <RadioGroup v-model="typeInfo.is_good_food">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
    <!--推荐-->
    <Modal v-model="showRecommendModalStatus"
           :title="title"
           @on-ok="editRecommend('recommendInfoValidate')"
           :loading="loading">
      <Form :model="recommendInfo"
            ref="recommendInfoValidate"
            :rules="recommendInfoValidate"
            action="javascript:void(0)">
        <FormItem label="推荐"
                  prop="is_recommend">
          <Select v-model="recommendInfo.is_recommend"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option :value="1"
                    :key="1">是</Option>
            <Option :value="0"
                    :key="0">否</Option>
          </Select>
        </FormItem>
        <FormItem label="首页推荐"
                  prop="is_index_recommend">
          <Select v-model="recommendInfo.is_index_recommend"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option :value="1"
                    :key="1">是</Option>
            <Option :value="0"
                    :key="0">否</Option>
          </Select>
        </FormItem>
        <FormItem label="虚拟定制量"
                  prop="false_data">
          <Input v-model="recommendInfo.false_data"
                 placeholder="虚拟定制量..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UploadVideo from "../common/video";
import UEditor from "../common/ueditor";

export default {
  name: "custom-made",
  data () {
    const validateStatus = (rule, value, callback) => {
      if (this.dataInfo.custom_made_cate_id === "") {
        callback(new Error("请选择审核状态"));
      } else {
        callback();
      }
    };
    const validateCateId = (rule, value, callback) => {
      if (this.dataInfo.custom_made_cate_id === "") {
        callback(new Error("请选择分类"));
      } else {
        callback();
      }
    };
    const validateIsFx = (rule, value, callback) => {
      if (this.dataInfo.is_fx === "") {
        callback(new Error("请选择是否分销"));
      } else {
        callback();
      }
    };
    const validateIsBuy = (rule, value, callback) => {
      if (this.dataInfo.is_buy === "") {
        callback(new Error("请选择是否开放购买"));
      } else {
        callback();
      }
    };
    return {
      showRecommendModalStatus: false,
      statusList: [
        { id: 1, name: "通过" },
        { id: 0, name: "待审核" },
        { id: -1, name: "不通过" }
      ],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      fx: "0",
      loading: true,
      dataloading: true,
      trandList: [],
      reviewInfo: {
        status: 0,
        comment: ""
      },
      typeInfo: {
        is_good_where: 0,
        is_good_craft: 0,
        is_good_experience: 0,
        is_good_food: 0,

      },
      // 编辑器用的
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      thumblist: [],
      title: "",
      formItem: {
        key: "",
        custom_made_cate_id: "",
        status: ""
      },
      ruleList: [],
      isable: true,
      bigDisplay: "",
      // 编辑器用的
      editor: {
        info: ""
      },
      showPriceModalStatus: false,
      showReviewModalStatus: false,
      showTypeModalStatus: false,
      thumblistTwo: [],
      videolist: [],
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "名称",
          key: "title",
          minWidth: 100
        },
        {
          title: "分类",
          key: "title",
          width: 100,
          render: (h, params) => {
            var par = params.row.cate != null ? params.row.cate.title : "";
            return h("span", {}, par);
          }
        },
        {
          title: "商家",
          key: "title",
          width: 100,
          render: (h, params) => {
            var par =
              params.row.tradesman != null ? params.row.tradesman.nickname : "";
            return h("span", {}, par);
          }
        },
        {
          title: "价格区间",
          key: "price_range",
          width: 100
        },
        {
          title: "最终价格",
          key: "price",
          width: 100
        },
        {
          title: "划线价格",
          key: "underline_price",
          width: 100
        },
        {
          title: "是否分销",
          width: 100,
          render: (h, params) => {
            var par = params.row.is_fx == 1 ? "是" : "否";
            return h(
              "tag",
              {
                props: {
                  color: params.row.is_fx == "1" ? "geekblue" : "red"
                }
              },
              par
            );
          }
        },
        {
          title: "代理商户比例",
          key: "agent_fx",
          width: 150
        },
        {
          title: "是否开放购买",
          width: 120,
          render: (h, params) => {
            var par = params.row.is_buy == 1 ? "是" : "否";
            return h(
              "tag",
              {
                props: {
                  color: params.row.is_buy == "1" ? "geekblue" : "red"
                }
              },
              par
            );
          }
        },
        {
          title: "排序",
          key: "sort",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "InputNumber",
                {
                  props: {
                    min: 0,
                    value: params.row.sort,
                    size: "small",
                    number: true
                  },
                  on: {
                    "on-change": value => {
                      this.sort(params.row.id, value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        // {
        //     title: '是否推荐',
        //     key: 'status',
        //     width:150,
        //     render: (h, params) => {
        //         return h('div', [
        //             h('i-switch', {
        //                 props: {
        //                     value: params.row.is_recommend==1 ? true:false  //控制开关的打开或关闭状态，官网文档属性是value
        //                 },
        //                 on: {
        //                     'on-change': (value) => {
        //                         this.changeStatus(params.row.id,value)
        //                     }
        //                 }
        //             }, '开关')
        //         ]);
        //     }
        // },
        {
          title: "推荐",
          key: "display",
          width: 100,
          render: (h, params) => {
            var par = params.row.is_recommend == 1 ? "是" : "否";
            return h(
              "tag",
              {
                props: {
                  color: params.row.is_recommend == "1" ? "geekblue" : "red"
                }
              },
              par
            );
          }
        },
        {
          title: "首页推荐",
          key: "display",
          width: 100,
          render: (h, params) => {
            var par = params.row.is_index_recommend == 1 ? "是" : "否";
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.is_index_recommend == "1" ? "geekblue" : "red"
                }
              },
              par
            );
          }
        },
        {
          title: "状态",
          key: "display",
          width: 100,
          render: (h, params) => {
            var par =
              params.row.status == 1
                ? "通过"
                : params.row.status == -1
                  ? "未通过"
                  : "待审核";
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.status == "1"
                      ? "geekblue"
                      : params.row.status == -1
                        ? "red"
                        : "orange"
                }
              },
              par
            );
          }
        },
        {
          title: "审核备注",
          key: "comment",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 400,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [

              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.changeType(params.row, params.row.id);
                    }
                  }
                },
                "分类"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detailPrice(params.index, params.row.id);
                    }
                  }
                },
                "编辑价格"
              ),

              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.changeRecommend(params.row, params.row.id);
                    }
                  }
                },
                "推荐"
              ),


              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.commentList(params.row.id);
                    }
                  }
                },
                "讨论"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    // display: params.row.status == "0" ? "inline-block" : "none"

                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.reviewPrice(params.index, params.row.id);
                    }
                  }
                },
                "审核"
              ),
              // h('Button', {
              //     style: {
              //         marginRight: '8px'
              //     },
              //     props: {
              //         type: 'error',
              //         size: 'small'
              //     },
              //     on: {
              //         click: () => {
              //             this.remove(params.index, params.row.id)
              //         }
              //     }
              // }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      custommadecateList: [],
      showModalStatus: false,
      dataInfoValidate: {
        title: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        price_range: [
          { required: true, message: "价格区间必须填写", trigger: "blur" }
        ],
        // price: [
        //   { required: true, message: "最终价格必须填写", trigger: "blur" }
        // ],
        custom_made_cate_id: [
          { required: true, validator: validateCateId, trigger: "change" }
        ],
        is_fx: [{ required: true, validator: validateIsFx, trigger: "change" }],
        is_buy: [
          { required: true, validator: validateIsBuy, trigger: "change" }
        ]
      },
      dataInfo: {
        title: "",
        custom_made_cate_id: "",
        price_range: "",
        price: "",
        is_fx: 0,
        is_chargecard: 1,
        pay_type: "1",
        is_buy: 0,
        album: "",
        descript: "",
        content: "",
        agent_fx: 0,
        agent_fx_money: 0,
        is_good_where: 0,
        is_good_craft: 0,
        is_good_experience: 0,
        is_good_food: 0,
        other_video_url: "",
        video_url: "",
        video_type: "0",
        keyword: ""
      },
      priceInfo: {
        price: "",
        status: 0
      },
      priceInfoValidate: {
        price: [
          { required: true, message: "价格区间必须填写", trigger: "blur" }
        ],
        status: [
          { required: true, validator: validateStatus, trigger: "change" }
        ]
      },
      reviewInfoValidate: {
        comment: [
          { required: true, message: "备注", trigger: "blur" }
        ],
      },
      recommendInfo: {},
      recommendInfoValidate: {},
      is_submit: true
    };
  },
  created: function () {
    this.$api.custommadecate.list({ size: 9999 }).then(res => {
      if (res.code == 200) {
        this.custommadecateList = res.result.list;
      }
    });
    // 取数据
    this.getTableList();
    this.getTrandList();
  },
  components: {
    // EditorBar,
    UploadThumb,
    UploadVideo,
    UEditor
  },
  methods: {
    getTableList: function () {
      this.renderTable(1);
      return
      // this.$api.custommade.list({ page: this.pages.page, size: this.pages.size })
      //   .then(res => {
      //     this.dataloading = false;
      //     if (res.code == 200) {
      //       this.tablelist = res.result.list;
      //       this.pages.total = res.result.total;
      //       this.$Message.success(res.msg);
      //     }
      //   });
      // return;
    },
    //添加定制价格
    addGoodRule () {
      this.ruleList.push({
        phone: null,
        price: null,
        status: 1
      });
    },
    deleteRule (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (
        (rule.price == null ||
          rule.price == undefined ||
          rule.price == "") &&
        (rule.phone == null ||
          rule.phone == undefined ||
          rule.phone == "") &&
        (rule.id == null || rule.id == undefined || rule.id == "")
      ) {
        that.realDeleteRule(index);
        return;
      }
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          that.realDeleteRule(index);
          this.is_submit = true;
        }
      });
    },
    realDeleteRule (index) {
      var that = this;
      var rule = that.ruleList[index];
      if (rule.id && rule.id != undefined && rule.id != "") {
        var params = {
          id: rule.id
        };
        that.$api.custommade.removeuserprice(params).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            that.$Message.success(res.msg);
            that.ruleList.splice(index, 1);
          } else {
            that.$Message.error(res.msg);
          }
        });
      } else {
        that.ruleList.splice(index, 1);
        that.$Message.success("删除成功");
      }
    },
    //修改价格
    reviewPrice (index, id) {
      this.title = "审核";
      this.reviewInfo = {
        status: 0,
        comment: ""
      };
      this.showReviewModalStatus = true;
      this.$api.custommade.detail({ id: id }).then(res => {
        this.reviewInfo = res.result;
      });
    },
    changeType (index, id) {
      this.title = "分类";
      this.typeInfo = {
        is_good_where: 0,
        is_good_craft: 0,
        is_good_experience: 0,
        is_good_food: 0,
      };
      this.showTypeModalStatus = !this.showTypeModalStatus;
      this.$api.custommade.detail({ id: id }).then(res => {
        this.typeInfo = res.result;
      });
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.videolist = [];
      this.dataInfo = {
        title: "",
        custom_made_cate_id: "",
        price_range: "",
        price: "",
        is_fx: 0,
        is_chargecard: 1,
        pay_type: "1",
        is_buy: 0,
        album: "",
        descript: "",
        content: "",
        video_type: "0",
        agent_fx: 0,
        agent_fx_money: 0,
        keyword: ""
      };
      this.$refs["dataInfoValidate"].resetFields();
      this.thumblistTwo = new Array();
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.custommade.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        this.dataInfo.from_uuid = res.result.uuid;
        this.editor.info = this.dataInfo.content;
        this.dataInfo.pay_type = this.dataInfo.pay_type.toString();
        this.dataInfo.video_type = this.dataInfo.video_type.toString();
        this.ruleList = res.result.custommadeuser;
        for (var k in this.ruleList) {
          this.ruleList[k].status = 1;
        }
        // this.$refs["editContent"].editor.txt.html(this.editor.info);
        this.$refs["editContent"].message = this.dataInfo.content;
        if (this.dataInfo.is_fx == 1) {
          this.isable = false;
        } else {
          this.isable = true;
        }
        if (this.dataInfo.video_url != null && this.dataInfo.video_url != "") {
          this.videolist.push({
            name: this.dataInfo.video_url,
            url: this.dataInfo.video_url,
            status: "finished"
          });
        }
        //处理thumb
        if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
          this.thumblist.push({
            name: this.dataInfo.thumb,
            url: this.dataInfo.thumb,
            status: "finished"
          });
        }
        this.sum();
        if (this.dataInfo.album != null && this.dataInfo.album.length > 0) {
          for (var s in this.dataInfo.attrShow) {
            this.thumblistTwo.push({
              name: this.dataInfo.attrShow[s],
              url: this.dataInfo.attrShow[s],
              status: "finished"
            });
          }
        }
      });
    },
    getTrandList () {
      this.$api.tradesman.list({ page: 1, size: 10000 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    //审核
    review (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.custommade.review(this.reviewInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showReviewModalStatus = false;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //审核
    editType (name) {
      this.$api.custommade.review(this.typeInfo).then(res => {
        if (res.code == 200) {
          this.getTableList();
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        this.showTypeModalStatus = !this.showTypeModalStatus;
      });
    },
    changeBeginDate (val) {
      this.dataInfo.end_at = val;
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.custommade.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 展开添加
    showModel () {
      this.title = "添加";
      this.dataInfo = {
        title: "",
        custom_made_cate_id: "",
        price_range: "",
        price: "",
        is_fx: 0,
        is_chargecard: 1,
        pay_type: "1",
        is_buy: 0,
        album: "",
        descript: "",
        content: "",
        video_type: "0",
        agent_fx: 0,
        agent_fx_money: 0,
        keyword: ""
      };
      this.$refs["dataInfoValidate"].resetFields();
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.thumblistTwo = new Array();
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        status: this.formItem.status,
        custom_made_cate_id: this.formItem.custom_made_cate_id,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.custommade.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    commentList (id) {
      this.$router.push("/customcomment/list/" + id);
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.custommade
        .isRecommend({ id: index, is_recommend: value })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.tablelist = [];
            this.renderTable(1);
          }
        });
    },
    changeRecommend: function (index, value) {
      this.title = "编辑";
      this.recommendInfo = {
        id: value,
        is_recommend: index.is_recommend,
        is_index_recommend: index.is_index_recommend,
        false_data: index.false_data,
      };
      this.showRecommendModalStatus = !this.showRecommendModalStatus;
    },
    editRecommend (name) {
      this.$refs[name].validate(valid => {
        if (valid) {

          this.$api.custommade
            .isRecommend({
              id: this.recommendInfo.id,
              is_recommend: this.recommendInfo.is_recommend,
              is_index_recommend: this.recommendInfo.is_index_recommend,
              false_data: this.recommendInfo.false_data,
            })
            .then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showRecommendModalStatus = !this.showRecommendModalStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    sort: function (id, sort) {
      this.$api.custommade.sort({ id: id, sort: sort }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    //编辑价格
    editPrice (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.custommade.price(this.priceInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showPriceModalStatus = !this.showPriceModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 添加
    createInfo (name) {
      this.$refs[name].validate(valid => {
        if (this.is_submit == false) {
          this.$Message.error("手机号不能重复");
          return;
        }
        if (valid && this.is_submit) {
          if (this.$refs["uploadthumb"].uploadList.length) {
            this.dataInfo.thumb = this.$refs[
              "uploadthumb"
            ].uploadList[0].url;
          }
          //相册
          if (this.dataInfo.is_buy == 1 && this.dataInfo.price <= 0) {
            this.$Message.error("开放购买时最终价格必须大于0");
            return;
          }
          if (this.dataInfo.agent_fx_money * 1 > this.dataInfo.price * 1) {

            this.$Message.error("设置的代理商户分销金额太大");
            this.loading = false;
            this.showModalStatus = this.showModalStatus;
          }
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.dataInfo.album = finalAttrs.substring(
                0,
                finalAttrs.length - 1
              );
            }
          } else {
            this.dataInfo.album = "";
          }
          if (this.dataInfo.video_type == 1) {
            if (this.$refs["uploadvideo"].videoList.length > 0) {
              this.dataInfo.video_url = this.$refs[
                "uploadvideo"
              ].videoList[0].url;
            } else {
              this.dataInfo.video_url = null;
            }
          }

          this.dataInfo.ruleList = this.ruleList;
          for (var ii in this.ruleList) {
            this.ruleList[ii].status = 1;
            if (this.ruleList[ii].price == null || this.ruleList[ii].price == "" || this.ruleList[ii].phone == null || this.ruleList[ii].phone == "") {
              this.ruleList[ii].status = 0;
              this.$Message.error("请填写定制用户信息");

              return;
            }
          }

          // return;
          this.dataInfo.content = this.$refs["editContent"].message;
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.custommade.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.custommade.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 改变分销比例
    agentFx: function (val) {
      // 返回的是 lable值
      if (val == "1") {
        this.isable = false;
      } else {
        this.isable = true;
      }
    },
    //计算分销
    sum () {
      var goodprice = this.dataInfo.price;
      //计算分成
      var agentfx = this.dataInfo.agent_fx;
      var fx = parseFloat(agentfx) / 100;
      var real = goodprice;
      if (agentfx != "") {
        this.fx = parseFloat(real * fx).toFixed(2);
      } else {
        this.fx = 0;
      }
    },
    //计算分销
    sum1 () {
      var agent_fx_money = parseFloat(this.dataInfo.agent_fx_money).toFixed(2);
      var madeprice = parseFloat(this.dataInfo.price).toFixed(2);

      console.log(typeof agent_fx_money, typeof madeprice)

      if (agent_fx_money * 1 > madeprice * 1) {
        this.$Message.error("设置的代理商户分销金额太大");
      }
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.custommade.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    //修改价格
    detailPrice (index, id) {
      this.title = "编辑";
      this.priceInfo = {
        price: "",
        underline_price: "",
        is_buy: 0
      };
      this.showPriceModalStatus = !this.showPriceModalStatus;
      this.priceInfo.id = id;
      this.$api.custommade.detail({ id: id }).then(res => {
        this.priceInfo = res.result;
      });
    },
    // 
    blurPhoneFun (index) {
      this.is_submit = true;
      var listStr = JSON.stringify(this.ruleList);
      var list = JSON.parse(listStr);
      var itemStr = JSON.stringify(list[index]);
      var item = JSON.parse(itemStr);
      list.splice(index, 1);
      for (let i in list) {
        if (list[i].phone == item.phone) {
          item.status = 0;
          this.is_submit = false;
          this.$Message.error("手机号不能重复");
          return;
        } else {
          item.status = 1;
        }
      }
      this.$set(this.ruleList, index, item)
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.borderRed .ivu-input {
  border-color: red;
}
</style>
